import * as React from 'react';
import classnames from 'classnames';

import SVGIcon from 'components/svg-icon/SVGIcon';

import type { SyntheticEvent } from 'react';

export function getBlockStyle(block: any): string | undefined | null {
  switch (block.getType()) {
    case 'blockquote': return 'rich-text-editor__blockquote';
    default: return null;
  }
}

type Props = {
  type: {
    style: string,
    icon: string
  },
  active: boolean,
  onToggle: (a: string) => void
};

export class StyleButton extends React.Component<Props> {
  handleToggle = (event: SyntheticEvent<HTMLSpanElement>) => {
    event.preventDefault();

    const { type, onToggle } = this.props;

    onToggle(type.style);
  };

  render() {
    const { type, active } = this.props;
    const buttonClasses = classnames({
      'rich-text-editor__button': true,
      'rich-text-editor__button--active': active
    });

    return (
      <span
        className={buttonClasses}
        onMouseDown={this.handleToggle}
      >
        <SVGIcon
          name={type.icon}
          width={20}
          height={20}
        />
      </span>
    );
  }
}
